import { t } from "i18next";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";

import { theme } from "@/src/theme/theme";

import { useAuth } from "@/src/auth/hooks/useAuth";

const EmailVerificationDialog = () => {
  const {
    isAuthenticated,
    isDealer,
    isEmailVerified,
    refreshUserInfo,
    logout,
    user
  } = useAuth();

  const handleResendVerificationEmail = async () => {
    console.log("handleResendVerificationEmail");
    // @ts-ignore
    window.ALMA?.account?.selfServiceVerifyEmailUrl?.();
    return;
  };

  const handleEmailVerificationDone = async () => {
    await refreshUserInfo();
    return;
  };

  return (
    <Dialog
      id="emailVerificationDialog"
      open={isAuthenticated && !isEmailVerified}
      onClose={() => null}
      maxWidth="xs"
    >
      <Box sx={{ p: 1, pt: 1, pb: 1.5 }}>
        <Box>
          <DialogTitle variant="h2" sx={{ pb: 0, mb: 0 }}>
            {t("emailVerification.title")}
          </DialogTitle>
        </Box>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              mb: 1.5
            }}
          >
            {t("emailVerification.paragraph1", {
              userType: isDealer
                ? t("emailVerification.almaBusinessAccount")
                : t("emailVerification.almaAccount"),
              email: user?.email
            })}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: 1.5,
              fontWeight: theme.typography.fontWeightBold
            }}
          >
            {t("emailVerification.paragraph2")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: 1.5
            }}
          >
            {t("emailVerification.paragraph3")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 1.5
            }}
          >
            {t("emailVerification.paragraph4")}{" "}
            <Typography
              component="span"
              variant="body1"
              onClick={handleResendVerificationEmail}
              sx={{
                color: theme.palette.semantic.primary.dark,
                cursor: "pointer",
                display: "inline",
                textDecoration: "underline"
              }}
            >
              {t("emailVerification.link")}
            </Typography>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              flexDirection: ["column-reverse", "row"],
              width: ["100%", "auto"],
              gap: [1.5, 0.75]
            }}
          >
            <Button variant="text" onClick={() => logout()}>
              {t("general.logout")}
            </Button>
            <Button
              id="emailVerificationDoneButton"
              variant="contained"
              color="primary"
              onClick={handleEmailVerificationDone}
            >
              {t("emailVerification.verified")}
            </Button>
          </Box>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default EmailVerificationDialog;
